// extracted by mini-css-extract-plugin
module.exports = {"hero":"NewHeroHubSpotForm_hero__foRyX","formMedia":"NewHeroHubSpotForm_formMedia__tmQXx","form":"NewHeroHubSpotForm_form___sM3p","text":"NewHeroHubSpotForm_text__0cyBr"};